import api from '../utils/api';

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT = 'LOGOUT';

export const login = (email, password) => async (dispatch) => {
  try {
    const res = await api.post('/auth/login', { email, password });
    const { token } = res.data;
    const user = parseJwt(token);
    localStorage.setItem('token', token);
    dispatch({
      type: LOGIN_SUCCESS,
      payload: { token, user },
    });
  } catch (error) {
    console.error('Login error:', error);
    // Handle errors as needed
  }
};

export const logout = () => {
  localStorage.removeItem('token');
  return {
    type: LOGOUT,
  };
};

// Helper function to parse JWT token
const parseJwt = (token) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace('-', '+').replace('_', '/');
    return JSON.parse(window.atob(base64));
  } catch (e) {
    return null;
  }
};
